window.orderPageAlert = function(message) {
    if (typeof vex !== 'undefined' && vex.dialog && typeof vex.dialog.alert === 'function') {
        vex.dialog.alert({
            unsafeMessage: message
        })
        return
    }

    const temp = document.createElement('div')
    temp.innerHTML = message
    window.alert(temp.textContent || temp.innerText || String(message))
}

window.orderPagePendingNotifications = window.orderPagePendingNotifications || []
window.orderPageFlushNotifications = function() {
    if (typeof Messenger === 'undefined') {
        return
    }

    while (window.orderPagePendingNotifications.length > 0) {
        const notification = window.orderPagePendingNotifications.shift()
        Messenger().post(notification)
    }
}

window.ORDER_PAGE_UI_HELPERS = {
    async notifyUser(mesArray, type = 'success', debug = false) {
        if (typeof mesArray === 'string') {
            mesArray = [mesArray]
        }

        if (!debug && typeof Messenger !== 'undefined') {
            mesArray.forEach(function(mes) {
                Messenger().post({
                    message: mes,
                    type: type,
                    showCloseButton: true
                })
            })
        } else if (!debug) {
            mesArray.forEach(function(mes) {
                window.orderPagePendingNotifications.push({
                    message: mes,
                    type: type,
                    showCloseButton: true
                })
            })
        } else {
            console.warn('[Notify] ' + JSON.stringify(mesArray))
        }
    },

    async copyText(text) {
        if (typeof text === 'string') {
            const textarea = document.createElement('textarea')
            textarea.value = text
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
            this.notifyUser($L('ords.successfull_copied') + ': ' + text)
        }
    },

    async scrollToTryItOut() {
        if (this.mobile && !this.isUserLoggedIn) {
            let infoBox = document.getElementById('info_box')

            if (infoBox) {
                infoBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    },

    async scrollToOrders() {
        const targetElement = document.querySelector('.orders')
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' })
        }
    },

    async lockBodyScroll() {
        let documentBody = document.getElementsByTagName('body')[0]
        documentBody.style.overflow = 'hidden'
        documentBody.style.position = 'fixed'
        documentBody.style.width = '100%'
    },

    async unlockBodyScroll() {
        let documentBody = document.getElementsByTagName('body')[0]
        documentBody.style.overflow = null
        documentBody.style.position = null
    },

    playNotification(ignoreMute = false) {
        if (!this.muted || ignoreMute) {
            let sound = document.getElementById('sms-audio')

            if (sound) {
                sound.currentTime = 0
                sound.play().catch(() => {})
            }
        }
    },

    hideWelcomeModal() {
        this.showWelcomeModal = false
    },

    showFavoritesF() {
        if (this.showFavorites) {
            localStorage.setItem('showCountryFavorites', false)
            this.showFavorites = false
        } else {
            if (!Array.isArray(this.favoritesCountry) || this.favoritesCountry.length < 1) {
                this.notifyUser($L('ords.no_favorite_country'), 'error')
            } else {
                localStorage.setItem('showCountryFavorites', true)
                this.showFavorites = true
            }
        }
    },

    filterServiceTop() {
        if (this.topServicesFiltered && Array.isArray(this.topServicesFiltered)) {
            for (let i = 0; i < this.topServicesFiltered.length; i++) {
                if (this.favoritesService && !this.favoritesService.includes(this.topServicesFiltered[i]) && !this.topServicesOpts.includes(this.topServicesFiltered[i])) {
                    this.topServicesFiltered.splice(i, 1)
                }
            }
        }

        if (this.favoritesService && Array.isArray(this.favoritesService)) {
            for (let i = 0; i < this.favoritesService.length; i++) {
                if (!this.topServicesFiltered.includes(this.favoritesService[i])) {
                    this.topServicesFiltered.unshift(this.favoritesService[i])
                } else if (this.topServicesFiltered.includes(this.favoritesService[i]) && this.topServicesOpts.includes(this.favoritesService[i])) {
                    let index = this.topServicesFiltered.indexOf(this.favoritesService[i])
                    let el = this.topServicesFiltered.splice(index, 1)
                    this.topServicesFiltered.unshift(el[0])
                }
            }
        }
    },

    checkFavoritesCountry(shortname) {
        if (!shortname || this.favoritesCountry == null || this.favoritesCountry.length < 1) {
            return false
        }
        return this.favoritesCountry.includes(shortname)
    },

    checkFavoritesService(opt) {
        if (!opt || this.favoritesService == null || this.favoritesService.length < 1) {
            return false
        }
        return this.favoritesService.includes(opt)
    },

    clickFavoritesService(opt) {
        if (!opt) {
            return false
        }

        if (this.favoritesService == null) {
            this.favoritesService = []
        }
        if (!this.favoritesService.includes(opt)) {
            this.favoritesService.push(opt)
        } else {
            let indexFavorites = this.favoritesService.indexOf(opt)
            this.favoritesService.splice(indexFavorites, 1)
            if (this.topServicesOpts.includes(opt) && this.topServicesFiltered.includes(opt)) {
                let index = this.topServicesOpts.indexOf(opt)
                let el = this.topServicesFiltered.splice(this.topServicesFiltered.indexOf(opt), 1)
                if (index <= indexFavorites) {
                    let indexEl = this.favoritesService.length - 1 < 0 ? 0 : this.favoritesService.length
                    this.topServicesFiltered.splice(indexEl, 0, el[0])
                } else {
                    this.topServicesFiltered.splice(index, 0, el[0])
                }
            }
        }
        if (this.topServicesFiltered.includes(opt) && this.favoritesService.includes(opt)) {
            let index = this.topServicesFiltered.indexOf(opt)
            let el = this.topServicesFiltered.splice(index, 1)
            this.topServicesFiltered.push(el)
        }
        localStorage.setItem('simsms_favs', JSON.stringify(this.favoritesService))
        this.filterServiceTop()
    },

    clickFavoritesCountry(shortname) {
        if (!shortname) {
            return false
        }
        if (this.favoritesCountry == null) {
            this.favoritesCountry = []
        }
        if (!this.favoritesCountry.includes(shortname)) {
            this.favoritesCountry.push(shortname)
        } else {
            this.favoritesCountry.splice(this.favoritesCountry.indexOf(shortname), 1)
        }
        localStorage.setItem('favorites_country', JSON.stringify(this.favoritesCountry))

        if (this.reverseMode) {
            this.filterCountryTop()
        }
    }
}
